import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const addMqlListener = (list: MediaQueryList, listener: () => void) => {
      if (typeof list.addEventListener === "function") list.addEventListener("change", listener);
      else list.addListener(listener);
    };

    const removeMqlListener = (list: MediaQueryList, listener: () => void) => {
      if (typeof list.removeEventListener === "function") list.removeEventListener("change", listener);
      else list.removeListener(listener);
    };

    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    addMqlListener(mql, onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => removeMqlListener(mql, onChange);
  }, []);

  return !!isMobile;
}
